import React from 'react';
import { tr } from '../../i18n';
import { parseAllergens, formatAllergens } from '../../utils/menuExtras';

export const AllergenPicker = ({ value, allergens, onChange, label, testId }) => {
  const selected = parseAllergens(value);
  const toggle = (n) =>
    onChange(formatAllergens(selected.includes(n) ? selected.filter((x) => x !== n) : [...selected, n]));

  return (
    <div className="md:col-span-2" data-testid={testId}>
      <span className="block text-[10px] font-bold text-black/50 uppercase tracking-widest mb-1.5">{label}</span>
      <div className="flex flex-wrap gap-1.5">
        {allergens.map((a) => {
          const on = selected.includes(a.n);
          return (
            <button
              key={a.n}
              type="button"
              onClick={() => toggle(a.n)}
              aria-pressed={on}
              data-testid={`${testId}-chip-${a.n}`}
              className={`px-2.5 py-1 rounded-full border-[1.5px] text-xs font-bold transition-colors ${on ? 'bg-black text-white border-black' : 'bg-white text-black/60 border-black/15 hover:border-black'}`}
            >
              {a.n} · {tr(a.name, 'it')}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AllergenPicker;
